document.addEventListener("DOMContentLoaded", function () {
  $(function () {
    $(".reward-program-faqs-title").click(function () {
      if ($(this).next(".reward-program-faqs-subtitle").is(":hidden")) {
        $(this).find("span").html("-");
      } else {
        $(this).find("span").html("+");
      }
      $(this).next(".reward-program-faqs-subtitle").slideToggle();
    });
    $(".a-totop").click(function () {
      $jq("html,body").animate(
        {
          scrollTop: $jq(".reward-program-middetails").offset().top - 50 + "px",
        },
        300
      );
    });
    if ($(window).width() > 1000) {
      $(window).scroll(function () {
        $(".animation-box").each(function () {
          if (
            $(window).scrollTop() + ($(window).height() * 2) / 3 >
            $(this).offset().top
          ) {
            $(this).addClass("animate-text");
          } else {
            $(this).removeClass("animate-text");
          }
        });
      });
    }
  });
});
